import { DateService } from '../../services/date.service';

interface GetPlantDateWarningCodesOptions {
    plantDate?: Date | null;
    plantDateCreatedAt?: Date | null;
    plantDateUpdatedAt?: Date | null;
    isParticipatingToBem: boolean;
}

const PLANT_DATE_RECORDED_LATE_WARNING_CODE = 'PlantDateRecordedLate';
const MIN_DELAY_DAYS = 8;
const MAX_DELAY_DAYS = 10;
const PLANT_DATE_MAX_DAYS_IN_PAST = 10;
const PLANT_DATE_MAX_DAYS_IN_FUTURE = 7;

export function getPlantDateLimits(
  dateService: Pick<DateService, 'daysInThePast' | 'daysInTheFuture'>,
): Readonly<{ min: Date; max: Date }> {
  return {
    min: dateService.daysInThePast(PLANT_DATE_MAX_DAYS_IN_PAST),
    max: dateService.daysInTheFuture(PLANT_DATE_MAX_DAYS_IN_FUTURE),
  };
}

export function getPlantDateWarningCodes({
    plantDate,
    plantDateCreatedAt,
    plantDateUpdatedAt,
    isParticipatingToBem,
}: GetPlantDateWarningCodesOptions): ReadonlyArray<string> {
    if (!isParticipatingToBem) {
        return [];
    }

    const latestRecordedAt = getLatestRecordedAt(plantDateCreatedAt, plantDateUpdatedAt);

    if (!plantDate || !latestRecordedAt) {
        return [];
    }

    const daysBetween = differenceInUtcDays(plantDate, latestRecordedAt);

    return daysBetween >= MIN_DELAY_DAYS && daysBetween <= MAX_DELAY_DAYS
      ? [PLANT_DATE_RECORDED_LATE_WARNING_CODE]
        : [];
}

function getLatestRecordedAt(
    plantDateCreatedAt?: Date | null,
    plantDateUpdatedAt?: Date | null,
): Date | null {
    if (plantDateCreatedAt && plantDateUpdatedAt) {
        return plantDateUpdatedAt >= plantDateCreatedAt ? plantDateUpdatedAt : plantDateCreatedAt;
    }

    return plantDateUpdatedAt ?? plantDateCreatedAt ?? null;
}

function differenceInUtcDays(start: Date, end: Date): number {
    const startUtc = Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate());
    const endUtc = Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate());

    return Math.floor((endUtc - startUtc) / 86_400_000);
}
